var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7695 9.72677H10.6152C8.88965 9.72677 8.02681 9.72677 7.38422 10.0921C6.96318 10.3314 6.61359 10.6756 6.37053 11.0901C5.99953 11.7229 5.99953 12.5724 5.99953 14.2714C5.99953 15.9703 5.99953 16.8198 6.37053 17.4526C6.61359 17.8672 6.96318 18.2114 7.38422 18.4507C8.02681 18.816 8.88965 18.816 10.6152 18.816H17.077M20.7695 9.72677L18.0002 7M20.7695 9.72677L18.0002 12.4535",
    stroke: "#1C274C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/symbol.4fb82cdc85515a2a7ab74bcaee934c98.svg";
export { ForwardRef as ReactComponent };